"use client";

import React from "react";
import { Users, ChevronRight } from "lucide-react";

export default function ReferralSection() {
    const handleReferralClick = () => {
        window.location.href = "https://app.sapieduca.com.br/ia/convidar";
    };

    return (
        <section className="py-24 bg-white relative overflow-hidden">
            {/* Background Decorations similar to other sections */}
            <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#3266cc]/5 rounded-full -mr-64 -mt-64 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#15b3a8]/5 rounded-full -ml-40 -mb-40 blur-3xl"></div>

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="bg-gradient-to-br from-[#3266cc] via-[#2855b0] to-[#1e3b75] rounded-[3rem] p-12 md:p-16 shadow-[0_40px_100px_-20px_rgba(50,102,204,0.3)] relative overflow-hidden group">
                    {/* Pattern Overlay */}
                    <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] pointer-events-none"></div>

                    {/* Animated Glow */}
                    <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#15b3a8] opacity-20 filter blur-[100px] group-hover:opacity-40 transition-opacity duration-1000"></div>

                    <div className="relative z-10 grid lg:grid-cols-5 gap-12 items-center">
                        <div className="lg:col-span-3 text-left">
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white text-xs font-black tracking-widest mb-6 uppercase">
                                <Users className="w-4 h-4" />
                                Programa de Indicação
                            </div>
                            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight tracking-tight">
                                Indique e <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-teal-200">ganhe créditos</span>
                            </h2>
                            <p className="text-xl text-blue-100/80 mb-8 leading-relaxed font-medium">
                                Compartilhe a Sapieduca IA com outros professores e ganhe créditos extras por cada novo cadastro realizado através do seu convite.
                            </p>
                        </div>

                        <div className="lg:col-span-2">
                            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-[2.5rem] p-8 md:p-10 text-center flex flex-col items-center shadow-2xl relative">
                                <span className="text-teal-200 font-black text-5xl mb-2 tracking-tighter">+5.000 $C</span>
                                <span className="text-white/60 text-sm font-bold uppercase tracking-widest mb-8">POR NOVO CADASTRO</span>

                                <button
                                    onClick={handleReferralClick}
                                    className="w-full py-5 rounded-full bg-white text-[#3266cc] font-black text-sm uppercase tracking-widest hover:bg-teal-50 transition-all shadow-xl hover:shadow-white/10 active:scale-95 flex items-center justify-center gap-2 group/btn"
                                >
                                    Convide Agora
                                    <ChevronRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
